import { Flame, Beef, Wheat, Droplet } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NutritionIconsProps {
  calories?: number;
  protein?: number;
  carbs?: number;
  fat?: number;
  className?: string;
  iconSize?: number;
  showLabels?: boolean;
}

export const NutritionIcons = ({ 
  calories, 
  protein, 
  carbs, 
  fat, 
  className,
  iconSize = 14,
  showLabels = true
}: NutritionIconsProps) => {
  return (
    <div className={cn("flex items-center gap-3 text-xs", className)}>
      {calories !== undefined && (
        <div className="flex items-center gap-1">
          <Flame className="text-orange-500" size={iconSize} />
          <span className="font-medium">{Math.round(calories)}{showLabels && ' cal'}</span>
        </div>
      )}
      {protein !== undefined && (
        <div className="flex items-center gap-1">
          <Beef className="text-red-500" size={iconSize} />
          <span>{Math.round(protein)}g{showLabels && ''}</span>
        </div>
      )}
      {carbs !== undefined && (
        <div className="flex items-center gap-1">
          <Wheat className="text-lime-500" size={iconSize} />
          <span>{Math.round(carbs)}g{showLabels && ''}</span>
        </div>
      )}
      {fat !== undefined && (
        <div className="flex items-center gap-1">
          <Droplet className="text-yellow-400" size={iconSize} />
          <span>{Math.round(fat)}g{showLabels && ''}</span>
        </div>
      )}
    </div>
  );
};
